import {
  Box,
  Text,
  Stack,
  Button,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import Link from "next/link";
import Image from "next/image";

export default function BenfitCard({ data, showIcon }) {
  const { Description, Icon, name, slug, Title } = data;

  return (
    <Flex
      maxW={"300px"}
      w={"full"}
      h={"100%"}
      bg={"white"}
      boxShadow={"rgba(0, 0, 0, 0.15) 0px 5px 15px 0px"}
      rounded={"lg"}
      flexDirection={"column"}
      overflow={"hidden"}
      py={8}
      px={3}
      cursor={"pointer"}
    >
      <Stack
        textAlign={"center"}
        color={useColorModeValue("gray.800", "white")}
        alignItems={"center"}
        mb={5}
      >
        <Text
          fontSize={"xl"}
          fontWeight={"normal"}
          color={"blue.10"}
          whiteSpace={"nowrap"}
          overflow={"hidden"}
          textOverflow={"ellipsis"}
        >
          {name || Title}
        </Text>
      </Stack>

      {showIcon && Icon?.data && (
        <Flex mb={5} justify={"center"}>
          <Image
            alt={Icon?.data?.attributes.name}
            src={
              process.env.NEXT_PUBLIC_SERVER_URL + Icon?.data?.attributes.url
            }
            height={50}
            width={150}
            style={{ objectFit: "scale-down", height: "50px" }}
          />
        </Flex>
      )}
      <Box h={"100%"} borderRadius={"0px 0px 10px 10px"}>
        <Text fontSize={"md"} fontWeight={"normal"} color={"lightBlue.10"}>
          {Description}
        </Text>
        {slug && (
          <Link href={"/technologies/" + slug}>
            <Button
              w={"full"}
              bg={"blue.10"}
              color={"white"}
              rounded={"lg"}
              _hover={{
                bg: "transparent",
                color: "blue.10",
                border: "1px",
                borderColor: "blue.10",
                borderStyle: "solid",
              }}
              _focus={{
                bg: "blue.10",
              }}
            >
              Read More
            </Button>
          </Link>
        )}
      </Box>
    </Flex>
  );
}
